import { render, staticRenderFns } from "./EvaluatorsDetail.vue?vue&type=template&id=7dda6018&scoped=true&"
import script from "./EvaluatorsDetail.vue?vue&type=script&lang=js&"
export * from "./EvaluatorsDetail.vue?vue&type=script&lang=js&"
import style0 from "./EvaluatorsDetail.vue?vue&type=style&index=0&id=7dda6018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dda6018",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BTh, BTr, BThead, BTd, BTbody, BTableSimple, BOverlay, BLink, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BTh, BTr, BThead, BTd, BTbody, BTableSimple, BOverlay, BLink, BContainer})
    

export default component.exports